<section class="login-page">
  <article class="login-form-area">
    <div class="login-card">

      <!-- Logo -->
      <div class="card-logo">
        <img src="assets/media/logos/logodef.svg" alt="Defontana" />
      </div>

      <mat-stepper [linear]="true" #stepper>
        <!-- Step 1: Datos de Registro -->
        <mat-step [stepControl]="firstFormGroup">
          <h1>¡Te damos la bienvenida<br>a Defontana!</h1>
          <p class="subtitle">
            Comienza tu <span class="highlight">prueba gratis</span>, para siempre. No necesitas tarjeta de crédito
          </p>

          <form [formGroup]="firstFormGroup" [attr.autocomplete]="'off'">
            
            <div class="field-group">
              <label class="field-label" for="rut-input">RUT</label>
              <mat-form-field appearance="fill" class="w-100">
                <input id="rut-input" matInput placeholder="12.345.678-9" formControlName="legalCode" (keyup)="onChange($event.target)">
              </mat-form-field>
            </div>

            <div class="field-group">
              <label class="field-label" for="name-input">Nombre y apellido</label>
              <mat-form-field appearance="fill" class="w-100">
                <input id="name-input" matInput placeholder="Defontana emprendedor" formControlName="name">
              </mat-form-field>
            </div>

            <div class="field-group">
              <label class="field-label" for="email-reg-input">Dirección de correo electrónico</label>
              <mat-form-field appearance="fill" class="w-100">
                <input id="email-reg-input" matInput placeholder="fran@defontana.com" type="email" formControlName="email">
              </mat-form-field>
            </div>

            <div class="field-group pass">
              <label class="field-label" for="password-reg-input">Contraseña</label>
              <mat-form-field appearance="fill" class="w-100">
                <input id="password-reg-input" matInput [type]="hide ? 'password' : 'text'" placeholder="contraseña" formControlName="password">
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide" type="button">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>

              <div class="dynamic-hint" [ngClass]="passwordHint.statusClass">
                <mat-icon>{{passwordHint.icon}}</mat-icon>
                <span>{{passwordHint.text}}</span>
              </div>
            </div>

            <small class="privacy-text">
              Al hacer clic en ingresar, aceptas la
              <a href="https://defontana.com/politica-de-privacidad/" target="_blank">Política de Privacidad</a>
              de defontana.com
            </small>

            <button class="btn-confirm" type="button" [disabled]="firstFormGroup.invalid" (click)="onNext()">Crear cuenta</button>

            <div class="social-divider">
              <span>O ingresa con</span>
            </div>

            <div class="social-buttons">
              <!-- Google -->
              <button type="button" class="social-btn google-btn" aria-label="Ingresar con Google">
                <img src="assets/media/logos/logoGoogle.svg" alt="Google" />
              </button>
              <!-- Facebook -->
              <button type="button" class="social-btn facebook-btn" aria-label="Ingresar con Facebook">
                <img src="assets/media/logos/logoFacebook.svg" alt="Facebook" />
              </button>
              <!-- LinkedIn -->
              <button type="button" class="social-btn linkedin-btn" aria-label="Ingresar con LinkedIn">
                <img src="assets/media/logos/logoLikedin.svg" alt="LinkedIn" />
              </button>
            </div>

            <p class="create-account">
              ¿Ya tienes cuenta? <a [routerLink]="'/login'">Inicia sesión</a>
            </p>
          </form>
        </mat-step>

        <!-- Step 2: Enlace de cuenta -->
        <mat-step [stepControl]="secondFormGroup">
          <h1>Enlaza tu cuenta a un usuario del sistema</h1>

          <form [formGroup]="secondFormGroup" [attr.autocomplete]="'off'">
            <div class="field-group">
              <label class="field-label">ID Cliente</label>
              <mat-form-field appearance="fill" class="w-100">
                <input matInput placeholder="ID Cliente" formControlName="idCliente">
              </mat-form-field>
            </div>

            <div class="field-group">
              <label class="field-label">Usuario ERP</label>
              <mat-form-field appearance="fill" class="w-100">
                <input matInput placeholder="Usuario ERP" formControlName="userErp">
              </mat-form-field>
            </div>

            <div class="field-group">
              <label class="field-label">Contraseña ERP</label>
              <mat-form-field appearance="fill" class="w-100">
                <input matInput [type]="hide ? 'password' : 'text'" placeholder="Contraseña ERP" formControlName="passwordErp">
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Mostrar contraseña'" type="button" [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <button class="btn-confirm" type="button" [disabled]="secondFormGroup.invalid" (click)="onNext()">Continuar</button>

            <p class="create-account">
              ¿Ya tienes cuenta? <a [routerLink]="'/login'">Inicia sesión</a>
            </p>
          </form>
        </mat-step>
      </mat-stepper>

    </div>
  </article>
</section>